module.exports = __webpack_public_path__ + "img/product_115.65b5f82.svg";